// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"38ae777e","389":"87e0462e","455":"75913667","970":"a74f498f","977":"c2b876c3"}[chunkId] + ".chunk.js";
};